const previewAudioCache = new Map();
let activePreview = null;

function previewUrl(family, id) {
  return `/sounds/previews/${family}/${encodeURIComponent(id)}.ogg`;
}

export function stopSoundfontPreview() {
  if (!activePreview) {
    return;
  }
  activePreview.pause();
  activePreview.currentTime = 0;
  activePreview = null;
}

export function playSoundfontPreview(family, id) {
  if (!family || !id) {
    stopSoundfontPreview();
    return;
  }

  const key = `${family}:${id}`;
  const audio = previewAudioCache.get(key) || new window.Audio(previewUrl(family, id));
  previewAudioCache.set(key, audio);
  stopSoundfontPreview();
  activePreview = audio;
  audio.currentTime = 0;
  audio.play().catch(() => {
    if (activePreview === audio) {
      activePreview = null;
    }
  });
}

export function preloadSoundfontPreview(family, id) {
  if (!family || !id) {
    return;
  }
  const key = `${family}:${id}`;
  if (previewAudioCache.has(key)) {
    return;
  }
  const audio = new window.Audio(previewUrl(family, id));
  audio.preload = "auto";
  previewAudioCache.set(key, audio);
}
